/**
 * @fileoverview Nav module events.
 */

import { EVENT_PREFIX } from "../../core/events";

/**
 * Navigation action events.
 */
export const NAV_EVENTS = {
  /** Set primary action button in navbar */
  SET_ACTION: `${EVENT_PREFIX}nav.setAction`,
  /** Clear the primary action button */
  CLEAR_ACTION: `${EVENT_PREFIX}nav.clearAction`,
  /** Notification when action button is clicked (host → iframe) */
  ACTION_CLICK: `${EVENT_PREFIX}nav.actionClick`,
  /** Add one sub-navigation item (iframe → host) */
  ADD_ITEM: `${EVENT_PREFIX}nav.addItem`,
  /** Ack with `value` and deprecated `id` (same string) (host → iframe; request response) */
  ADD_ITEM_RESPONSE: `${EVENT_PREFIX}nav.addItem.response`,
  UPDATE_ITEM: `${EVENT_PREFIX}nav.updateItem`,
  REMOVE_ITEM: `${EVENT_PREFIX}nav.removeItem`,
  /** Injected sub-nav item clicked (host → iframe) */
  ITEM_CLICK: `${EVENT_PREFIX}nav.itemClick`,
} as const;
